import { Grid, Typography, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./SignIn.css";
import logo from "../../assets/Group 154.webp";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import Checkbox from "@mui/material/Checkbox";
import companyIcon from "../../assets/004-company.svg";
import mobileIcon from "../../assets/003-mobile.svg";
import lockIcon from "../../assets/001-password.svg";
import { executeApi } from "../../utils/WithAuth";
import { variables } from "../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import PopupAlert from "../../components/PopupAlert/PopupAlert";
import { login } from "../redux/features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { setForgetPasswordTrue } from "../redux/features/session/sessionslice";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { v4 } from "uuid";
import { MobileFriendly } from "@mui/icons-material";

const SignIn = () => {
  const baseUrl = useSelector((state) => state.baseURL);
  const [showPopup, setShowPopup] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const dispatch = useDispatch();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [mobileNo, setMobileNo] = useState("");
  const [password, setPassword] = useState("");
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [message, setMessage] = useState("");
  const [severty, setSeverty] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchCompaniesByPhone = async (mobile) => {
    if (!mobile || mobile.length < 4) return; // minimal check
    try {
      const res = await executeApi(
        `${baseUrl}/v1/Auth/companiesByPhone?mobileNo=${mobile}`,
        {},
        "GET",
        null,
        dispatch
      );
      if (res && Array.isArray(res)) {
		const list = res;
        setCompanies(list);
		if (list.length === 1) {
          setSelectedCompany(list[0]);
        } else {
          setSelectedCompany("");
        }
		
      } else {
        setCompanies([]);
        setSelectedCompany("");
      }
    } catch (err) {
      console.error("Error fetching companies:", err);
      setCompanies([]);
      setSelectedCompany("");
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (mobileNo.trim() !== "") {
        fetchCompaniesByPhone(mobileNo.trim());
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [mobileNo]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") reqSignin();
  };

  const reqSignin = () => {
    if (!mobileNo || !password || !selectedCompany) {
      setSeverty("error");
      setMessage("Mobile No, Company, and Password are required!");
      setShowPopup(true);
      return;
    }

    setLoadingState(true);

    const payload = {
      mobileNumber: mobileNo,
      companyName: selectedCompany,
      password: password,
    };

    executeApi(`${baseUrl}/v1/Auth/AuthenticateUser2`, payload, "POST", null, dispatch)
      .then((data) => {
        setSeverty(data.success ? "success" : "error");
        setMessage(data.message);
        setLoadingState(false);
        setShowPopup(true);
        if (data.success) {
          dispatch(login(data.data));
          navigate("/dashboard"); // or desired page
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setSeverty("error");
        setMessage(error.message);
        setShowPopup(true);
        setLoadingState(false);
      });
  };

  const handleClosePopup = () => setShowPopup(false);

  const openForgetDialogue = () => dispatch(setForgetPasswordTrue());

  return (
    <>
      <Grid container className="signInPage">
        <Grid container item md={8} sm={8} xs={12}>
          <Grid item md={1} sm={1} xs={0.25}></Grid>
          <Grid item container md={11} sm={11} xs={11.5}>
            <Grid item onClick={() => navigate("/")} md={12} className="signInLogoSection">
              <img src={logo} height="60px" alt="Candle Logo" />
            </Grid>
            <Grid item container md={12} xs={12} className="signInSectionFoam">
              <Typography variant="h4">Welcome to Candle Thread.</Typography>

              <Grid item container md={12}>
                <Grid item md={7} sm={9} xs={10.5} className="custom-input-container">
                  <Input
                    onKeyPress={handleKeyPress}
                    type="text"
                    value={mobileNo}
                    setValue={setMobileNo}
                    placeholder=" Mobile Number"
                  />
                  <span className="custom-icon">
                    <img src={mobileIcon} alt="mobile" />
                  </span>
                </Grid>

              <Grid item md={5}></Grid>
				<Grid item md={7} sm={9} xs={10.5} className="custom-input-container">
				<div className="custom-input-wrapper">
					<select
						className="custom-dropdown"
						value={selectedCompany}
						onChange={(e) => setSelectedCompany(e.target.value)}
						required
						>
						<option value="">Select Company</option>
						{companies.map((company, index) => (
							<option key={index} value={company}>
							{company}
							</option>
						))}
					</select>

					<span className="custom-icon">
					<img src={companyIcon} alt="icon" />
					</span>
				</div>
				</Grid>

                <Grid item md={5}></Grid>
                <Grid item md={7} sm={9} xs={10.5} className="custom-input-container">
                  <Input
                    onKeyPress={handleKeyPress}
                    type={showPassword ? "text" : "password"}
                    placeholder=" Password"
                    value={password}
                    setValue={setPassword}
                  />
                  <span className="custom-icon">
                    <img src={lockIcon} alt="icon" />
                  </span>
                  <button
                    onClick={() => setShowPassword(!showPassword)}
                    className="custom-icon-2"
                    style={{ border: "none", outline: "none", color: "gray", background: "none" }}
                  >
                    {!showPassword ? <VisibilityOffOutlinedIcon title="Hide" /> : <VisibilityIcon title="Show" />}
                  </button>
                </Grid>

                <Grid container item md={7} sm={10} xs={12}>
                  <Grid item md={6} sm={6} xs={screenWidth > 320 ? 6 : 12}>
                    <Typography variant="body2">
                      <Checkbox {...label} defaultChecked /> Remember me
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    sm={6}
                    xs={screenWidth > 320 ? 6 : 12}
                    style={{
                      textAlign: "right",
                      display: "flex",
                      cursor: "pointer",
                      justifyContent: screenWidth > 320 ? "flex-end" : "flex-start",
                      paddingRight: "0%",
                      alignItems: "center",
                      paddingLeft: "10px",
                    }}
                  >
                    <Typography variant="body2" onClick={() => openForgetDialogue()}>
                      Forgot Password?
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item md={5} xs={0}></Grid>
                <Grid item md={5} sm={9} xs={12}>
                  <Button onClick={reqSignin} buttonName={"Sign In"} loadingState={loadingState} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item md={4} sm={4} sx={{ display: { xs: "none", sm: "block" } }} className="signInPageBack flex"></Grid>
      </Grid>

      <PopupAlert open={showPopup} message={message} severty={severty} onClose={handleClosePopup} />
    </>
  );
};

export default SignIn;
